import Image from "next/image";
import Link from "next/link";
import React from "react";

import Remote from "../LoaderRemote";

const SidebarContentItem = ({ data }) => {
  return (
    <div className="sidebar-blog-item flex flex-row items-center justify-between py-2">
      <div className="caption flex flex-col pe-2">
        <h2 className="mb-0 fs-7">
          <Link href={data.url} title={data.title}>
            <a title={data.title} className="text-md font-medium ">
              {data.baslik}
            </a>
          </Link>
        </h2>
      </div>
      <div className="item-img shrink-0">
        <div className="w-24 h-16 rounded-lg overflow-hidden relative">
          {data.resim && (
            <Image
              objectFit="cover"
              objectPosition={"center"}
              src={data.resim}
              alt={data.title}
              loader={Remote}
              width={96}
              height={64}
            ></Image>
          )}
        </div>
      </div>
    </div>
  );
};

export default SidebarContentItem;
